import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'app/shared/shared.module';
import { AddMenuComponent } from './add-menu.component';

@NgModule({
  declarations: [AddMenuComponent],
  imports: [MatButtonModule, MatDividerModule, MatIconModule, MatMenuModule, SharedModule],
  exports: [AddMenuComponent],
})
export class AddMenuModule {}
